import React from 'react';
import { Link } from 'react-router-dom';
import { SparklesIcon } from '@heroicons/react/24/outline';
import { useWhatsNew } from '../../hooks/useWhatsNew';
import { releases } from '../../help/releases';
import { useAuth } from '../../contexts/AuthContext';
import { useAiStatus } from '../../hooks/useAiStatus';
import { isStaff } from '../../types/auth';

/**
 * A kezdőlapon jelzi a legutóbbi, a felhasználóra vonatkozó újdonságot, amíg meg
 * nem nézte. A stábnak szóló vagy AI-t igénylő újdonságot nem hirdetjük annak,
 * akinek nem elérhető (pl. vendég, vagy ha az AI ki van kapcsolva).
 */
const WhatsNewBanner: React.FC = () => {
  const { seen, markSeen } = useWhatsNew();
  const { user } = useAuth();
  const ai = useAiStatus();
  const latest = releases.find(
    (r) => (r.audience !== 'staff' || isStaff(user)) && (!r.requiresAi || ai.available),
  );
  if (!latest || latest.date <= seen) return null;

  return (
    <div className="mb-6 flex flex-col gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4 sm:flex-row sm:items-center">
      <SparklesIcon className="hidden h-6 w-6 shrink-0 text-amber-600 sm:block" />
      <div className="flex-1 text-sm">
        <p className="font-semibold text-gray-900">Újdonság: {latest.title}</p>
        <p className="text-gray-700">{latest.items[0]?.text}</p>
      </div>
      <div className="flex shrink-0 items-center gap-3 text-sm">
        <button type="button" onClick={markSeen} className="text-gray-500 hover:text-gray-700">
          Később
        </button>
        <Link
          to="/features"
          className="rounded-md bg-amber-500 px-3 py-1.5 font-medium text-white shadow-sm hover:bg-amber-600"
        >
          Megnézem
        </Link>
      </div>
    </div>
  );
};

export default WhatsNewBanner;
